import { COVER_CARRY_RETURN_TO, leadTokenOf } from '../publicMode/publicCoverPath';
import { browserCoverStorage, writeCarry } from '../publicMode/publicCoverStore';

/**
 * The "Start free" link of the "Your cover is saved" email is `/app/auth?email=…&coverDesign=<token>`
 * (music24-api `coverLeadSignUpUrl`). After the sign-in or the sign-up, the page that puts the
 * design on a song opens. This keeps the token as the carried design and gives the `returnTo` of
 * that page; null for a link with no valid token (the sign-in then goes on as usual).
 */
export function takeCoverDesignLink(coverDesign: string | null | undefined): string | null {
  const token = leadTokenOf(coverDesign);
  if (token === null) {
    return null;
  }
  writeCarry(browserCoverStorage(), token);
  return COVER_CARRY_RETURN_TO;
}
